import { Schema } from 'normalizr';

export const snapcodeSchema = new Schema('snapcode', { idAttribute: 'id' });
